// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"92df246c","839":"90eed7b2"}[chunkId] + ".chunk.js";
};